import { useRoute } from "vue-router";
import { useRuntimeConfig } from "#app";

/**
 * Get szmd voting status
 * @deprecated remove this function and use useSzmdConfig instead
 * @returns true if SZMD voting is in progress, false otherwise
 */
export const useSzmdVotingStatus = () => {
	// TODO - remove this function and use useSzmdConfig instead
	const config = useRuntimeConfig();

	const szmdVotingStartAt = new Date(config.public.activeConfig.szmdConfig.votingStartAt + "T00:00:00").getTime();
	const szmdVotingFinishAt = new Date(config.public.activeConfig.szmdConfig.votingFinishAt + "T23:59:59").getTime();
	const now = new Date().getTime();
	const szmdVotingInProgress = szmdVotingStartAt < now && szmdVotingFinishAt > now;

	return szmdVotingInProgress;
};

/**
 * Get Szmd related config and status
 *
 * @returns Szmd related config and status
 */
export const useSzmdConfig = () => {
	const config = useRuntimeConfig();
	const route = useRoute();
	const now = new Date().getTime();

	const szmdVotingStartAt = new Date(config.public.activeConfig.szmdConfig.votingStartAt + "T00:00:00").getTime();
	const szmdVotingFinishAt = new Date(config.public.activeConfig.szmdConfig.votingFinishAt + "T23:59:59").getTime();

	const szmdVotingInProgress = szmdVotingStartAt < now && szmdVotingFinishAt > now;

	const szmdStart = new Date(config.public.activeConfig.szmdConfig.entryStartAt + "T00:00:00").getTime();
	const szmdEnd = new Date(config.public.activeConfig.szmdConfig.shutdown + "T23:59:59").getTime();
	const isSzmdPeriod = szmdStart < now && szmdEnd > now;
	const isSzmdVotingPage = route.meta?.pageType === "szmd-voting" || route.meta?.pageType === "szmd-box-voting";

	const szmdVotingModalHide = config.public.activeConfig.szmdConfig.votingModalHide;

	const szmdCtaBannerHide = config.public.activeConfig.szmdConfig.ctaBannerHide;

	const szmdInlineVote = config.public.activeConfig.szmdConfig.inlineVote;

	const szmdPrizes = config.public.activeConfig.szmdConfig.prizes;

	return {
		szmdVotingStartAt,
		szmdVotingFinishAt,
		szmdVotingInProgress,
		isSzmdVotingPage,
		isSzmdPeriod,
		szmdVotingModalHide,
		szmdCtaBannerHide,
		szmdInlineVote,
		szmdPrizes,
	};
};
